module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_8011.b9bec01f.png";